// AlertMessage: status/feedback component (success/error/info)
import React from "react";

const styles = {
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  error: "bg-rose-50 text-rose-700 border-rose-200",
  info: "bg-blue-50 text-blue-700 border-blue-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
};

export default function AlertMessage({
  type = "info",
  title,
  children,
  onClose,
}) {
  return (
    <div
      className={`relative rounded-md border p-3 text-sm ${
        styles[type] || styles.info
      }`}
    >
      {title && <div className="mb-1 font-semibold">{title}</div>}
      <div>{children}</div>
      {onClose && (
        <button
          onClick={onClose}
          className="absolute right-2 top-2 text-xs opacity-70 hover:opacity-100"
        >
          ✕
        </button>
      )}
    </div>
  );
}
